import React, { useState } from "react";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

const SendIndividualEmail = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const sendEmail = async () => {
    const res = await fetch("/api/emails/send-individual", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, message }),
    });

    if (res.ok) {
      setEmail("");
      setMessage("");
      toast.success("Email sent successfully!");
    } else {
      toast.error("Failed to send email.");
    }
  };

  return (
    <div className="space-y-4">
      <h2 className="text-xl font-semibold">Send Individual Email</h2>
      <Input
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="Enter recipient email"
      />
      <Textarea
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        placeholder="Write your message..."
        className="min-h-[150px]"
      />
      <Button onClick={sendEmail}>Send Email</Button>
    </div>
  );
};

export default SendIndividualEmail;
